// src/aiq/services/MarketDataService.ts

import { API_BASE_URL } from '../../config'; 

export const fetchBatchPrices = async (tickers: string[], token: string): Promise<Record<string, number>> => {
    if (tickers.length === 0) return {};

    try {
        const response = await fetch(`${API_BASE_URL}/data/batch_prices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ tickers })
        });

        if (!response.ok) {
            const text = await response.text();
            console.error(`AiQ Price API Error (${response.status}):`, text);
            return {};
        }

        const data = await response.json();
        return data; 

    } catch (error) {
        console.error("AiQ: Failed to fetch market prices", error);
        return {};
    }
};

// --- NEW FUNCTION for StrategyLab ---
export const fetchBatchHistory = async (tickers: string[], token: string): Promise<Record<string, number[]>> => {
    if (tickers.length === 0) return {};

    try {
        const response = await fetch(`${API_BASE_URL}/history/batch`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ tickers })
        });

        if (!response.ok) {
            const text = await response.text();
            console.error(`AiQ History API Error (${response.status}):`, text);
            return {};
        }

        const data = await response.json();
        return data; 

    } catch (error) {
        console.error("AiQ: Failed to fetch market history", error);
        return {};
    }
};